import { mdiDeleteForever, mdiFileEdit } from "@mdi/js";
import {
  OptGrid,
  OptGridColumn,
  OptGridOptions,
  OptGridRef,
  OptGridRequest,
  OptGridResponse,
} from "@optsol/react";
import React from "react";
import { Colors } from "../../../compartilhado/colors";
import { OptGridContainer } from "../../../componentes/OptGridContainer";
import { PessoaSearchResponse } from "../../../modelos/dtos/PessoaSearchResponse";

interface Props {
  onRowClick: (rowData?: PessoaSearchResponse) => void;
  carregar: (
    data: OptGridRequest
  ) => Promise<OptGridResponse<PessoaSearchResponse>>;
  abrirDrawerFormulario: () => void;
  onClickDelete: (rowData: PessoaSearchResponse) => void;
  onClickEdit: (rowData: PessoaSearchResponse) => void;
  gridRef: React.MutableRefObject<OptGridRef | null>;
}

const options: OptGridOptions = {
  search: true,
  pageSize: 10,
};

export const GridUsuariosView = React.forwardRef<OptGridRef | undefined, Props>(
  (
    {
      carregar,
      onRowClick,
      abrirDrawerFormulario,
      onClickDelete,
      onClickEdit,
      gridRef,
    },
    ref
  ) => {
    const columns: OptGridColumn<PessoaSearchResponse>[] = [
      
      {
        title: "Id",
        field: "id",
        align: "left",
        hidden: true,
      },
      {
        title: "Nome",
        field: "nome",
        align: "left",
        hidden: false,
        width: 15,
      },
      {
        title: "CPF",
        field: "cpf",
        align: "left",
        hidden: false,
        width: 200,
      },
      {
        title: "Telefone",
        field: "telefone",
        align: "left",
        hidden: false,
        width: 300,
      },
      {
        title: "E-mail",
        field: "email",
        align: "left",
        hidden: false,
        width: 300,
      },
      {
        title: "Perfil",
        field: "perfil",
        align: "left",
        hidden: false,
        width: 300,
      }
    ];

    return (
      <>
        <OptGridContainer>
          <OptGrid
            title=""
            ref={gridRef}
            columns={columns}
            data={carregar}
            options={options}
            onRowClick={onRowClick}
            actionsPosition={"end"}
            actions={[
              (rowData) => ({
                icon: {
                  path: mdiFileEdit,
                  size: 1,
                  color: Colors.gray,
                },
                tooltip: "Editar usuário",
                onClick: () => onClickEdit(rowData),
                disabled: true,
              }),
              (rowData) => ({
                icon: {
                  path: mdiDeleteForever,
                  size: 1,
                  color: Colors.red2,
                },
                tooltip: "Excluir usuário",
                onClick: () => onClickDelete(rowData),
                disabled: false,
              }),
            ]}
          />
        </OptGridContainer>
      </>
    );
  }
);
